// Tool registry ported from the iLoveImgPdf reference, extended with the option
// schema and processing key each tool uses.

export const TOOLS = {
  // ---------- IMAGE ----------
  compress: {
    cat: 'img',
    name: 'Compress Image',
    desc: 'Shrink JPG & PNG files without losing visible quality.',
    accept: 'image/*',
    action: 'Compress image',
    opts: 'quality',
    how: [
      'Add the image you want to make smaller.',
      'Pick a compression level that suits you.',
      'Download the lighter file in seconds.',
    ],
    seotitle:'Compress Image Online Free - Reduce JPG, PNG & WebP Size',
    metadis:'Compress JPG, PNG and WebP images online for free. Reduce image file size without losing quality in seconds.',
    keyword:'compress image, image compressor, jpg compressor, png compressor, webp compressor, reduce image size'
  },
  resize: {
    cat: 'img',
    name: 'Resize Image',
    desc: 'Set an exact width and height in pixels or percent.',
    accept: 'image/*',
    action: 'Resize image',
    opts: 'dims',
    how: ['Upload your photo.', 'Type the new width and height.', 'Download the resized image.'],
    seotitle:'Resize Image Online Free - Change Image Dimensions',
    metadis:'Resize JPG, PNG and WebP images online by pixels or percentage. Fast, free and easy image resizer.',
    keyword:'resize image, image resizer, change image size, resize jpg, resize png'
  },
  crop: {
    cat: 'img',
    name: 'Crop Image',
    desc: 'Trim and reframe with handy aspect-ratio presets.',
    accept: 'image/*',
    action: 'Crop image',
    opts: 'crop',
    how: ['Upload your image.', 'Drag to select the area to keep.', 'Download your cropped result.'],
    seotitle:'Crop Image Online Free - Crop JPG, PNG & WebP',
    metadis:'Crop images online with custom size or aspect ratio. Fast and free image crop tool.',
    keyword:'crop image, image cropper, crop jpg, crop png, crop photo'
  },
  convert: {
    cat: 'img',
    name: 'Convert Image',
    desc: 'Switch between JPG, PNG, WebP and more.',
    accept: 'image/*',
    action: 'Convert image',
    opts: 'imgformat',
    how: ['Upload any image.', 'Pick the output format.', 'Download the converted file.'],
    seotitle:'Convert Image Online Free - JPG, PNG, WebP Converter',
    metadis:'Convert images between JPG, PNG, WebP and other formats online for free.',
    keyword:'image converter, convert image, jpg to png, png to jpg, webp converter'
  },
  removebg: {
    cat: 'img',
    name: 'Remove Background',
    desc: 'Erase the backdrop in one click and keep the subject.',
    accept: 'image/*',
    action: 'Remove background',
    opts: 'removebg',
    outExt: 'png',
    seotitle:'Remove Image Background Online Free - AI Background Remover',
    metadis:'Remove image backgrounds automatically with AI. Create transparent PNG images instantly.',
    keyword:'remove background, background remover, ai background remover, transparent png',
    badge: 'NEW',
    how: [
      'Upload a photo with a clear subject.',
      'Pick the background colour to erase.',
      'Download a transparent PNG.',
    ],
  },
  rotate: {
    cat: 'img',
    name: 'Rotate & Flip',
    desc: 'Straighten or mirror your photos by any angle.',
    accept: 'image/*',
    action: 'Apply changes',
    opts: 'rotate',
    how: ['Upload your image.', 'Rotate or flip until it looks right.', 'Download the adjusted photo.'],
    seotitle:'Rotate & Flip Image Online Free',
    metadis:'Rotate or flip JPG, PNG and WebP images online with one click.',
    keyword:'rotate image, flip image, image rotator, image flipper, rotate jpg, flip png'
  },
  upscale: {
    cat: 'img',
    name: 'Upscale Image',
    desc: 'Boost resolution and sharpen small pictures.',
    accept: 'image/*',
    action: 'Upscale image',
    opts: 'scale',
    how: ['Upload a small image.', 'Choose how much to enlarge it.', 'Download the larger version.'],
    seotitle:'Upscale Image Online Free - Increase Image Resolution',
    metadis:'Increase image resolution and improve image quality online using AI.',
    keyword:'upscale image, image enhancer, image resolution, ai upscale, increase image size'
  },
  watermark: {
    cat: 'img',
    name: 'Add Watermark',
    desc: 'Stamp text to protect your images.',
    accept: 'image/*',
    action: 'Add watermark',
    opts: 'watermark',
    how: ['Upload your image.', 'Type your watermark and place it.', 'Download the protected image.'],
    seotitle:'Add Watermark to Image Online Free',
    metadis:'Add text watermark to JPG, PNG and WebP images online to protect your photos.',
    keyword:'watermark image, add watermark, image watermark'
  },
  blurface: {
    cat: 'img',
    name: 'Blur Face',
    desc: 'Blur faces or any area to protect privacy.',
    accept: 'image/*',
    action: 'Blur image',
    opts: 'blurface',
    how: [
      'Upload your photo.',
      'Drag boxes over the faces or areas to hide.',
      'Set the blur strength and download.',
    ],
    seotitle:'Blur Face in Image Online Free',
    metadis:'Blur faces or selected areas in photos online to protect privacy quickly and easily.',
    keyword:'blur face, blur image, face blur, image privacy'
  },
  img2pdf: {
    cat: 'img',
    name: 'Image to PDF',
    desc: 'Turn one or many photos into a single PDF.',
    accept: 'image/*',
    multi: true,
    action: 'Create PDF',
    opts: 'pagesize',
    outExt: 'pdf',
    how: ['Upload one or more images.', 'Set page size and orientation.', 'Download your new PDF.'],
    seotitle:'Image to PDF Converter Online Free',
    metadis:'Convert JPG, PNG and WebP images into high quality PDF files online for free.',
    keyword:'image to pdf, jpg to pdf, png to pdf, photo to pdf'
  },

  // ---------- PDF ----------
  merge: {
    cat: 'pdf',
    name: 'Merge PDF',
    desc: 'Combine several PDFs into one, in any order.',
    accept: 'application/pdf',
    multi: true,
    action: 'Merge PDFs',
    opts: 'reorder',
    outExt: 'pdf',
    how: ['Add two or more PDF files.', 'Drag them into the order you want.', 'Download the combined PDF.'],
    seotitle:'Merge PDF Online Free - Combine PDF Files',
    metadis:'Merge multiple PDF files into one document online for free. Fast and secure PDF merger.',
    keyword:'merge pdf, combine pdf, pdf merger'
  },
  split: {
    cat: 'pdf',
    name: 'Split PDF',
    desc: 'Pull out pages or break a file into parts.',
    accept: 'application/pdf',
    action: 'Split PDF',
    opts: 'pages',
    outExt: 'pdf',
    how: ['Upload your PDF.', 'Choose the pages or ranges to extract.', 'Download the split file.'],
    seotitle:'Split PDF Online Free - Extract PDF Pages',
    metadis:'Split PDF files or extract specific pages online quickly and securely.',
    keyword:'split pdf, extract pdf pages, pdf splitter'
  },
  compresspdf: {
    cat: 'pdf',
    name: 'Compress PDF',
    desc: 'Make heavy PDFs small enough to email.',
    accept: 'application/pdf',
    action: 'Compress PDF',
    opts: 'level',
    outExt: 'pdf',
    how: ['Upload the large PDF.', 'Pick a compression level.', 'Download the smaller file.'],
    seotitle:'Compress PDF Online Free - Reduce PDF File Size',
    metadis:'Compress PDF files online without losing quality. Reduce PDF size for email and sharing.',
    keyword:'compress pdf, reduce pdf size, pdf compressor'
  },
  pdf2word: {
    cat: 'pdf',
    name: 'PDF to Word',
    desc: 'Convert to an editable document you can change.',
    accept: 'application/pdf',
    action: 'Convert to Word',
    opts: 'none',
    outExt: 'doc',
    how: ['Upload your PDF.', 'iLoveImgPdf extracts the text.', 'Download the editable document.'],
    seotitle:'PDF to Word Converter Online Free',
    metadis:'Convert PDF files into editable Word documents online quickly and accurately.',
    keyword:'pdf to word, convert pdf to docx, pdf converter'
  },
  word2pdf: {
    cat: 'pdf',
    name: 'Word to PDF',
    desc: 'Turn .doc and .docx into clean, fixed PDFs.',
    accept: '.doc,.docx,.txt',
    action: 'Convert to PDF',
    opts: 'none',
    outExt: 'pdf',
    how: ['Upload your Word document.', 'iLoveImgPdf lays it out.', 'Download the finished PDF.'],
    seotitle:'Word to PDF Converter Online Free',
    metadis:'Convert DOC and DOCX files into high-quality PDF documents online for free.',
    keyword:'word to pdf, doc to pdf, docx to pdf'
  },
  pdf2ppt: {
    cat: 'pdf',
    name: 'PDF to PPT',
    desc: 'Turn each PDF page into a slide.',
    accept: 'application/pdf',
    action: 'Convert to PPT',
    opts: 'none',
    outExt: 'pptx',
    how: ['Upload your PDF.', 'Each page becomes a slide image.', 'Download the PowerPoint file.'],
    seotitle:'PDF to PowerPoint Converter Online Free',
    metadis:'Convert PDF files into editable PowerPoint presentations online.',
    keyword:'pdf to ppt, pdf to powerpoint'
  },
  ppt2pdf: {
    cat: 'pdf',
    name: 'PPT to PDF',
    desc: 'Convert PowerPoint slides to a PDF.',
    accept: '.ppt,.pptx',
    action: 'Convert to PDF',
    opts: 'none',
    outExt: 'pdf',
    how: ['Upload your .ppt or .pptx file.', 'Slide text is laid out per page.', 'Download the PDF.'],
    seotitle:'PowerPoint to PDF Converter Online Free',
    metadis:'Convert PowerPoint presentations into PDF documents online quickly.',
    keyword:'ppt to pdf, powerpoint to pdf'
  },
  pdf2excel: {
    cat: 'pdf',
    name: 'PDF to Excel',
    desc: 'Extract rows and text into a spreadsheet.',
    accept: 'application/pdf',
    action: 'Convert to Excel',
    opts: 'none',
    outExt: 'xlsx',
    how: ['Upload your PDF.', 'Text is grouped into rows and columns.', 'Download the .xlsx file.'],
    seotitle:'PDF to Excel Converter Online Free',
    metadis:'Convert PDF tables into editable Excel spreadsheets online.',
    keyword:'pdf to excel, pdf to xlsx,convert pdf to xlsx, pdf converter'
  },
  excel2pdf: {
    cat: 'pdf',
    name: 'Excel to PDF',
    desc: 'Render spreadsheets as a clean PDF.',
    accept: '.xls,.xlsx,.csv',
    action: 'Convert to PDF',
    opts: 'none',
    outExt: 'pdf',
    how: ['Upload your spreadsheet.', 'Each sheet becomes a page table.', 'Download the PDF.'],
    seotitle:'Excel to PDF Converter Online Free',
    metadis:'Convert Excel spreadsheets into PDF documents online with high quality.',
    keyword:'excel to pdf, xls to pdf, xlsx to pdf, convert excel to pdf'
  },
  pdf2jpg: {
    cat: 'pdf',
    name: 'PDF to JPG',
    desc: 'Save every page as a high-quality image.',
    accept: 'application/pdf',
    action: 'Convert to JPG',
    opts: 'imgquality',
    outExt: 'zip',
    how: ['Upload your PDF.', 'Choose the image quality.', 'Download all pages as images.'],
    seotitle:'PDF to JPG Converter Online Free',
    metadis:'Convert PDF pages into high-quality JPG images online for free.',
    keyword:'pdf to jpg, convert pdf to jpg,pdf to image'
  },
  editpdf: {
    cat: 'pdf',
    name: 'Edit PDF',
    desc: 'Add text, images and freehand drawing on the page.',
    accept: 'application/pdf',
    action: 'Apply edits',
    opts: 'editpdf',
    outExt: 'pdf',
    how: [
      'Upload the PDF to edit.',
      'Add text, images or draw drag to position.',
      'Apply and download your edited PDF.',
    ],
    seotitle:'Edit PDF Online Free - Modify PDF Files Easily',
    metadis:'Edit PDF files online by adding text, images, shapes and drawings.',
    keyword:'edit pdf, add text to pdf, pdf editor'
  },
  sign: {
    cat: 'pdf',
    name: 'Sign PDF',
    desc: 'Draw a signature and place it fast.',
    accept: 'application/pdf',
    action: 'Sign PDF',
    opts: 'sign',
    outExt: 'pdf',
    how: ['Upload the document to sign.', 'Draw your signature.', 'Download the signed PDF.'],
    seotitle:'Sign PDF Online Free - Add Digital Signature',
    metadis:'Add your signature to PDF documents online quickly and securely.',
    keyword:'sign pdf, pdf signature, digital signature'
  },
  protect: {
    cat: 'pdf',
    name: 'Protect PDF',
    desc: 'Lock files with a password before you share.',
    accept: 'application/pdf',
    action: 'Protect PDF',
    opts: 'password',
    outExt: 'pdf',
    how: ['Upload the PDF to secure.', 'Set a strong password.', 'Download the protected file.'],
    seotitle:'Protect PDF Online Free - Add Password to PDF',
    metadis:'Protect your PDF documents with a password online for free.',
    keyword:'protect pdf, pdf password, password protect pdf,secure pdf'
  },
  unlock: {
    cat: 'pdf',
    name: 'Unlock PDF',
    desc: 'Remove the password from a PDF you can open.',
    accept: 'application/pdf',
    action: 'Unlock PDF',
    opts: 'unlock',
    outExt: 'pdf',
    how: ['Upload the protected PDF.', 'Enter its password.', 'Download the unlocked file.'],
    seotitle:'Unlock PDF Online Free - Remove PDF Password',
    metadis:'Unlock protected PDF documents online by entering the correct password.',
    keyword:'unlock pdf, remove pdf password, open protected pdf'
  },
  wmpdf: {
    cat: 'pdf',
    name: 'Watermark PDF',
    desc: 'Stamp text across every page.',
    accept: 'application/pdf',
    action: 'Add watermark',
    opts: 'wmpdf',
    outExt: 'pdf',
    how: ['Upload your PDF.', 'Type the watermark text and style.', 'Download the watermarked PDF.'],
    seotitle:'Add Watermark to PDF Online Free',
    metadis:'Add text watermark to PDF documents online to protect your files.',
    keyword:'watermark pdf, add watermark, pdf watermark'
  },
  rotatepdf: {
    cat: 'pdf',
    name: 'Rotate PDF',
    desc: 'Rotate all pages by 90, 180 or 270°.',
    accept: 'application/pdf',
    action: 'Rotate PDF',
    opts: 'rotatepdf',
    outExt: 'pdf',
    how: ['Upload your PDF.', 'Choose the rotation.', 'Download the rotated PDF.'],
    seotitle:'Rotate PDF Online Free - Rotate PDF Pages',
    metadis:'Rotate PDF pages online by 90, 180 or 270 degrees quickly and easily.',
    keyword:'rotate pdf, rotate pdf pages, pdf rotator'
  },
  pagenum: {
    cat: 'pdf',
    name: 'Add Page Numbers',
    desc: 'Stamp page numbers on every page.',
    accept: 'application/pdf',
    action: 'Add numbers',
    opts: 'pagenum',
    outExt: 'pdf',
    how: ['Upload your PDF.', 'Pick the format and position.', 'Download the numbered PDF.'],
    seotitle:'Add Page Numbers to PDF Online Free',
    metadis:'Insert page numbers into PDF documents online with custom position and style.',
    keyword:'add page numbers, number pdf pages, pdf page numbering'
  },
}

export const ORDER_IMG = [
  'compress',
  'resize',
  'crop',
  'convert',
  'removebg',
  'blurface',
  'rotate',
  'upscale',
  'watermark',
  'img2pdf',
]
export const ORDER_PDF = [
  'merge',
  'split',
  'compresspdf',
  'pdf2word',
  'word2pdf',
  'pdf2ppt',
  'ppt2pdf',
  'pdf2excel',
  'excel2pdf',
  'pdf2jpg',
  'editpdf',
  'sign',
  'protect',
  'unlock',
  'wmpdf',
  'rotatepdf',
  'pagenum',
]

export const COLORS = {
  img: { c: '#2563EB', t: '#EAF1FE', g: 'rgba(37,99,235,.18)' },
  pdf: { c: '#E5484D', t: '#FCECEC', g: 'rgba(229,72,77,.18)' },
}

// Lucide icon name per tool.
export const ICN = {
  compress: 'shrink',
  resize: 'scaling',
  crop: 'crop',
  convert: 'refresh-cw',
  removebg: 'scissors',
  blurface: 'scan-face',
  rotate: 'rotate-cw',
  upscale: 'maximize-2',
  watermark: 'stamp',
  img2pdf: 'file-image',
  merge: 'copy-plus',
  split: 'split',
  compresspdf: 'file-minus',
  pdf2word: 'file-type',
  word2pdf: 'file-output',
  pdf2ppt: 'presentation',
  ppt2pdf: 'file-up',
  pdf2excel: 'table',
  excel2pdf: 'file-spreadsheet',
  pdf2jpg: 'image-down',
  editpdf: 'file-pen-line',
  sign: 'signature',
  protect: 'file-lock',
  unlock: 'lock-open',
  wmpdf: 'stamp',
  rotatepdf: 'rotate-cw',
  pagenum: 'hash',
}

// Card gradient per tool (matches the reference vibrant card icons).
export const GRAD = {
  compress: 'linear-gradient(140deg,#FF6B6B,#EE5A24)',
  resize: 'linear-gradient(140deg,#A29BFE,#6C5CE7)',
  crop: 'linear-gradient(140deg,#FD79A8,#E84393)',
  convert: 'linear-gradient(140deg,#55EFC4,#00B894)',
  removebg: 'linear-gradient(140deg,#74B9FF,#0984E3)',
  blurface: 'linear-gradient(140deg,#A78BFA,#7C3AED)',
  rotate: 'linear-gradient(140deg,#FDCB6E,#E17055)',
  upscale: 'linear-gradient(140deg,#6C5CE7,#A29BFE)',
  watermark: 'linear-gradient(140deg,#FD79A8,#D63031)',
  img2pdf: 'linear-gradient(140deg,#55EFC4,#00CEC9)',
  merge: 'linear-gradient(140deg,#74B9FF,#6C5CE7)',
  split: 'linear-gradient(140deg,#FF7675,#D63031)',
  compresspdf: 'linear-gradient(140deg,#FDCB6E,#F9CA24)',
  pdf2word: 'linear-gradient(140deg,#74B9FF,#0984E3)',
  word2pdf: 'linear-gradient(140deg,#A29BFE,#6C5CE7)',
  pdf2ppt: 'linear-gradient(140deg,#FDBA74,#EA580C)',
  ppt2pdf: 'linear-gradient(140deg,#FB923C,#DC2626)',
  pdf2excel: 'linear-gradient(140deg,#6EE7B7,#059669)',
  excel2pdf: 'linear-gradient(140deg,#34D399,#047857)',
  pdf2jpg: 'linear-gradient(140deg,#FD79A8,#E84393)',
  editpdf: 'linear-gradient(140deg,#55EFC4,#00B894)',
  sign: 'linear-gradient(140deg,#FDCB6E,#E17055)',
  protect: 'linear-gradient(140deg,#FF6B6B,#EE5A24)',
  unlock: 'linear-gradient(140deg,#34D399,#16A34A)',
  wmpdf: 'linear-gradient(140deg,#FCA5A5,#E5484D)',
  rotatepdf: 'linear-gradient(140deg,#FCD34D,#F59E0B)',
  pagenum: 'linear-gradient(140deg,#A5B4FC,#6366F1)',
}

export function gradColor(id) {
  const m = (GRAD[id] || '#4F46E5').match(/#[0-9a-fA-F]{6}/)
  return m ? m[0] : '#4F46E5'
}
